export const APP_MODAL = {
  needAccreditation: 'need-accreditation',
}
